//CORE
import {AfterViewInit, Injectable, OnDestroy, OnInit} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

//OBSERVABLE
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

//MODEL
import {Badge} from '../model/badge';
import { environment } from '../../environments/environment';
import {Avatar} from "../model/avatar";


@Injectable()
export class ProfilePageService {

    constructor(private http: Http) {
        this.http = http;
    }

    getAllAvatars(key: string): Observable<Avatar[]> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({headers: headers});
        return this.http.get(environment.base_url + 'Rest_User/all_avatars', options)
            .map((response: Response) => response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

    changeAvatar(idUser: number, idCourse: number, idAvatar: number, key: string): Observable<JSON> {
        const headers = new Headers();
        const body = {
            'user_id': idUser,
            'id_course': idCourse,
            'id_avatar': idAvatar
        };
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({headers: headers});
        return this.http
            .post(environment.base_url + 'Rest_User/save_avatar/', body, options)
            .map((response: Response) => response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

    getSoftChart(course_id: number, user_id: number, key: string): Observable<JSON[]> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({headers: headers});
        return this.http.get(environment.base_url + 'Rest_Charts/soft_chart/id_course/' + course_id + '/user_id/' + user_id, options)
            .map((response: Response) => response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

    getHardChart(course_id: number, user_id: number, key: string): Observable<JSON[]> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({headers: headers});
        return this.http.get(environment.base_url + 'Rest_Charts/hard_chart/id_course/' + course_id + '/user_id/' + user_id, options)
            .map((response: Response) => response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

    getScoreChart(course_id: number, user_id: number, key: string): Observable<JSON[]> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({headers: headers});
        return this.http.get(environment.base_url + 'Rest_Charts/line_chart/id_course/' + course_id + '/user_id/' + user_id, options)
            .map((response: Response) => response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

    getBadges(user_id: number, course_id: number, key: string): Observable<Badge[]> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({headers: headers});
        return this.http.get(environment.base_url + 'Rest_User/badges/user_id/' + user_id + '/id_course/' + course_id, options)
            .map((response: Response) => <Badge>response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/services/profile-page.service.ts